/**
 * @generated SignedSource<<40315b7701a206c6f6339072adb5cccd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type youQuery$variables = {
  weekId: string;
  includeDraft: boolean;
};
export type youQueryVariables = youQuery$variables;
export type youQuery$data = {
  readonly viewer: {
    readonly user: {
      readonly userActiveOneOnOneRelationshipUsers: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
        readonly email: string | null;
        readonly entityId: string;
        readonly viewerIsUser: boolean;
        readonly viewerUserRelationship: {
          readonly isOneOnOneActive: boolean;
          readonly oneOnOneMeetings: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly entityId: string;
                readonly scheduledAt: DateString;
              } | null;
            } | null> | null;
          } | null;
          readonly nextRecurringOneOnOneMeeting: {
            readonly scheduledAt: DateString;
            readonly entityId?: string;
          } | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"NextMeetingCard_user">;
      }>;
      readonly nativeDeviceTokens: ReadonlyArray<{
        readonly deviceUniqueId: string;
        readonly deviceToken: string;
      }>;
      readonly tasksList: ReadonlyArray<{
        readonly __typename: "RespondToSurveyTask";
        readonly survey: {
          readonly name: string;
          readonly entityId: string;
        };
      } | {
        readonly __typename: "PerformReviewsTask";
        readonly reviewCycle: {
          readonly entityId: string;
          readonly name: string;
        };
      } | {
        readonly __typename: "RespondToPulseTask";
        readonly id: string;
        readonly pulseGroup: {
          readonly entityId: string;
        } | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null>;
      readonly activeGoals: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"GoalCard_goal">;
          };
        } | null> | null;
      } | null;
      readonly siblings: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entityId: string;
            readonly preferredName: string | null;
            readonly title: string | null;
            readonly email: string | null;
            readonly name: string | null;
            readonly avatarUrl: string | null;
          } | null;
        } | null> | null;
      } | null;
      readonly viewerIsUser: boolean;
      readonly entityId: string;
      readonly name: string | null;
      readonly preferredName: string | null;
      readonly title: string | null;
      readonly startDate: DateString | null;
      readonly phoneNumber: string | null;
      readonly timezone: string | null;
      readonly realTimezone: string | null;
      readonly email: string | null;
      readonly avatarUrl: string | null;
      readonly department: {
        readonly name: string | null;
      } | null;
      readonly manager: {
        readonly email: string | null;
        readonly entityId: string;
      } | null;
      readonly reportsList: ReadonlyArray<{
        readonly entityId: string;
        readonly preferredName: string | null;
        readonly avatarUrl: string | null;
        readonly title: string | null;
        readonly email: string | null;
        readonly name: string | null;
      } | null> | null;
      readonly products: {
        readonly updates: {
          readonly isEnabled: boolean;
        };
        readonly feedback: {
          readonly isEnabled: boolean;
        };
      };
    };
    readonly managerCheckinRelationship: {
      readonly manager: {
        readonly entityId: string;
        readonly preferredName: string | null;
        readonly title: string | null;
        readonly email: string | null;
        readonly name: string | null;
        readonly avatarUrl: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"NextMeetingCard_user">;
      } | null;
      readonly hasAnyCheckins: boolean;
      readonly isCheckinsActive: boolean;
      readonly checkinByWeekId: {
        readonly published: boolean;
      } | null;
      readonly oneOnOneMeetings: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entityId: string;
            readonly id: string;
            readonly scheduledAt: DateString;
          } | null;
        } | null> | null;
      } | null;
      readonly nextRecurringOneOnOneMeeting: {
        readonly scheduledAt?: DateString;
        readonly id?: string;
      } | null;
    } | null;
    readonly receivedFeedback: {
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"FeedbackCard_feedback">;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type youQueryResponse = youQuery$data;
export type youQuery = {
  variables: youQueryVariables;
  response: youQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeDraft"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "weekId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerIsUser",
  "storageKey": null
},
v7 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "NextMeetingCard_user"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOneOnOneActive",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledAt",
  "storageKey": null
},
v11 = [
  (v5/*: any*/)
],
v12 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "OneOnOneMeeting",
  "abstractKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceUniqueId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceToken",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "Priority"
  },
  {
    "kind": "Literal",
    "name": "state",
    "value": "ACTIVE"
  }
],
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 15
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "realTimezone",
  "storageKey": null
},
v25 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isEnabled",
    "storageKey": null
  }
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "UserProducts",
  "kind": "LinkedField",
  "name": "products",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProductSettings",
      "kind": "LinkedField",
      "name": "updates",
      "plural": false,
      "selections": (v25/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProductSettings",
      "kind": "LinkedField",
      "name": "feedback",
      "plural": false,
      "selections": (v25/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAnyCheckins",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCheckinsActive",
  "storageKey": null
},
v29 = [
  {
    "kind": "Variable",
    "name": "includeDraft",
    "variableName": "includeDraft"
  },
  {
    "kind": "Variable",
    "name": "weekId",
    "variableName": "weekId"
  }
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "published",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 5
    }
  ],
  "concreteType": "checkinRelationshipOneOnOneMeetingsConnection",
  "kind": "LinkedField",
  "name": "oneOnOneMeetings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "checkinRelationshipOneOnOneMeetingsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OneOnOneMeeting",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v2/*: any*/),
            (v10/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "oneOnOneMeetings(first:5)"
},
v32 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = [
  (v2/*: any*/)
],
v35 = [
  (v5/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v4/*: any*/),
  (v3/*: any*/),
  (v20/*: any*/),
  (v2/*: any*/)
],
v36 = [
  (v3/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "youQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "userActiveOneOnOneRelationshipUsers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CheckinRelationship",
                    "kind": "LinkedField",
                    "name": "viewerUserRelationship",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": (v9/*: any*/),
                        "concreteType": "checkinRelationshipOneOnOneMeetingsConnection",
                        "kind": "LinkedField",
                        "name": "oneOnOneMeetings",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "checkinRelationshipOneOnOneMeetingsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OneOnOneMeeting",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "oneOnOneMeetings(first:1)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "nextRecurringOneOnOneMeeting",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NativeDeviceToken",
                "kind": "LinkedField",
                "name": "nativeDeviceTokens",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tasksList",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ViewerSurvey",
                        "kind": "LinkedField",
                        "name": "survey",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "RespondToSurveyTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReviewCycle",
                        "kind": "LinkedField",
                        "name": "reviewCycle",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PerformReviewsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PulseGroup",
                        "kind": "LinkedField",
                        "name": "pulseGroup",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "RespondToPulseTask",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "activeGoals",
                "args": (v16/*: any*/),
                "concreteType": "userOwnedGoalsConnection",
                "kind": "LinkedField",
                "name": "ownedGoals",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "userOwnedGoalsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "GoalCard_goal"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "ownedGoals(last:100,orderBy:\"Priority\",state:\"ACTIVE\")"
              },
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "userSiblingsConnection",
                "kind": "LinkedField",
                "name": "siblings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "userSiblingsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "siblings(first:15)"
              },
              (v6/*: any*/),
              (v5/*: any*/),
              (v3/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v4/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Department",
                "kind": "LinkedField",
                "name": "department",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "manager",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "reportsList",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v18/*: any*/),
                  (v20/*: any*/),
                  (v19/*: any*/),
                  (v4/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v26/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CheckinRelationship",
            "kind": "LinkedField",
            "name": "managerCheckinRelationship",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "manager",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v20/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "alias": null,
                "args": (v29/*: any*/),
                "concreteType": "Checkin",
                "kind": "LinkedField",
                "name": "checkinByWeekId",
                "plural": false,
                "selections": [
                  (v30/*: any*/)
                ],
                "storageKey": null
              },
              (v31/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nextRecurringOneOnOneMeeting",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v2/*: any*/)
                    ],
                    "type": "OneOnOneMeeting",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v32/*: any*/),
            "concreteType": "viewerReceivedFeedbackConnection",
            "kind": "LinkedField",
            "name": "receivedFeedback",
            "plural": false,
            "selections": [
              (v33/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "viewerReceivedFeedbackEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Feedback",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "FeedbackCard_feedback"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "receivedFeedback(first:10)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "youQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "userActiveOneOnOneRelationshipUsers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v18/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CheckinRelationship",
                    "kind": "LinkedField",
                    "name": "viewerUserRelationship",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": (v9/*: any*/),
                        "concreteType": "checkinRelationshipOneOnOneMeetingsConnection",
                        "kind": "LinkedField",
                        "name": "oneOnOneMeetings",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "checkinRelationshipOneOnOneMeetingsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OneOnOneMeeting",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v10/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "oneOnOneMeetings(first:1)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "nextRecurringOneOnOneMeeting",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v10/*: any*/),
                          (v12/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NativeDeviceToken",
                "kind": "LinkedField",
                "name": "nativeDeviceTokens",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tasksList",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ViewerSurvey",
                        "kind": "LinkedField",
                        "name": "survey",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "type": "RespondToSurveyTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReviewCycle",
                        "kind": "LinkedField",
                        "name": "reviewCycle",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v3/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "type": "PerformReviewsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PulseGroup",
                        "kind": "LinkedField",
                        "name": "pulseGroup",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "RespondToPulseTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ApprovePeerNominationsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "CalibrateTalentReviewTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ConfirmReceivingPacketTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "CreateGoalForGoalCycleTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "DocumentsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "EnableOneOnOneTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "EndRevieweeCycleTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "FinalizeReviewPacketTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "GiveFeedbackTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "PTORequestTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "PerformPostScoringReviewTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "PerformTalentReviewTaskType",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "PublishGrowthAreaReminderTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "RespondToBackboneEmployeeRegistrationFormTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "RespondToSurveyAssignmentTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ReviewCompensationCycleTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ReviewReportCheckinTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ScoreRevieweeTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "SelectPeersTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "SetupOneOnOnesWithNewReportTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "SetupUpdatesWithNewReportTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ShareCompensationCycleResultsToTeamTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "StartSurveyManagerActionPlanningTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "UpdateGoalTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "UpdateGoalsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "UpdateTotalRewardsCompanyCurrencyTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ViewCalibrationGroupsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ViewCompensationCycleResultsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ViewCompensationCycleTeamResultsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ViewCompensationTotalRewardsStatementTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ViewSharedCompensationCycleResultsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ViewSurveyActionPlanTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v34/*: any*/),
                    "type": "ViewSurveyCommentTask",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": "activeGoals",
                "args": (v16/*: any*/),
                "concreteType": "userOwnedGoalsConnection",
                "kind": "LinkedField",
                "name": "ownedGoals",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "userOwnedGoalsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "childrenList",
                            "plural": true,
                            "selections": (v34/*: any*/),
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "private",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "state",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": "amountType",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedAmountType",
                            "storageKey": null
                          },
                          {
                            "alias": "goalAmount",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedGoalAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "progressAmount",
                            "storageKey": null
                          },
                          {
                            "alias": "startingAmount",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedStartingAmount",
                            "storageKey": null
                          },
                          {
                            "alias": "type",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedProgressAmount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "ownedGoals(last:100,orderBy:\"Priority\",state:\"ACTIVE\")"
              },
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "userSiblingsConnection",
                "kind": "LinkedField",
                "name": "siblings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "userSiblingsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v35/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "siblings(first:15)"
              },
              (v6/*: any*/),
              (v5/*: any*/),
              (v3/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v4/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Department",
                "kind": "LinkedField",
                "name": "department",
                "plural": false,
                "selections": (v36/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "manager",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "reportsList",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v18/*: any*/),
                  (v20/*: any*/),
                  (v19/*: any*/),
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v26/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CheckinRelationship",
            "kind": "LinkedField",
            "name": "managerCheckinRelationship",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "manager",
                "plural": false,
                "selections": (v35/*: any*/),
                "storageKey": null
              },
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "alias": null,
                "args": (v29/*: any*/),
                "concreteType": "Checkin",
                "kind": "LinkedField",
                "name": "checkinByWeekId",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v31/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nextRecurringOneOnOneMeeting",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "type": "OneOnOneMeeting",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v32/*: any*/),
            "concreteType": "viewerReceivedFeedbackConnection",
            "kind": "LinkedField",
            "name": "receivedFeedback",
            "plural": false,
            "selections": [
              (v33/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "viewerReceivedFeedbackEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Feedback",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CompanyValue",
                        "kind": "LinkedField",
                        "name": "companyValues",
                        "plural": true,
                        "selections": (v36/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "targets",
                        "plural": true,
                        "selections": (v34/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v3/*: any*/),
                          (v18/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Competency",
                        "kind": "LinkedField",
                        "name": "competency",
                        "plural": false,
                        "selections": (v36/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "receivedFeedback(first:10)"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ef4990a203c87fec137549d1e1d273ea",
    "id": null,
    "metadata": {},
    "name": "youQuery",
    "operationKind": "query",
    "text": "query youQuery(\n  $weekId: String!\n  $includeDraft: Boolean!\n) {\n  viewer {\n    user {\n      userActiveOneOnOneRelationshipUsers {\n        id\n        name\n        email\n        entityId\n        viewerIsUser\n        ...NextMeetingCard_user\n        viewerUserRelationship {\n          isOneOnOneActive\n          oneOnOneMeetings(first: 1) {\n            edges {\n              node {\n                entityId\n                scheduledAt\n                id\n              }\n            }\n          }\n          nextRecurringOneOnOneMeeting {\n            __typename\n            scheduledAt\n            ... on OneOnOneMeeting {\n              entityId\n            }\n            id\n          }\n          id\n        }\n      }\n      nativeDeviceTokens {\n        deviceUniqueId\n        deviceToken\n        id\n      }\n      tasksList {\n        __typename\n        ... on RespondToSurveyTask {\n          survey {\n            name\n            entityId\n            id\n          }\n          id\n        }\n        ... on PerformReviewsTask {\n          reviewCycle {\n            entityId\n            name\n            id\n          }\n          id\n        }\n        ... on RespondToPulseTask {\n          id\n          pulseGroup {\n            entityId\n            id\n          }\n        }\n        ... on ApprovePeerNominationsTask {\n          id\n        }\n        ... on CalibrateTalentReviewTask {\n          id\n        }\n        ... on ConfirmReceivingPacketTask {\n          id\n        }\n        ... on CreateGoalForGoalCycleTask {\n          id\n        }\n        ... on DocumentsTask {\n          id\n        }\n        ... on EnableOneOnOneTask {\n          id\n        }\n        ... on EndRevieweeCycleTask {\n          id\n        }\n        ... on FinalizeReviewPacketTask {\n          id\n        }\n        ... on GiveFeedbackTask {\n          id\n        }\n        ... on PTORequestTask {\n          id\n        }\n        ... on PerformPostScoringReviewTask {\n          id\n        }\n        ... on PerformTalentReviewTaskType {\n          id\n        }\n        ... on PublishGrowthAreaReminderTask {\n          id\n        }\n        ... on RespondToBackboneEmployeeRegistrationFormTask {\n          id\n        }\n        ... on RespondToSurveyAssignmentTask {\n          id\n        }\n        ... on ReviewCompensationCycleTask {\n          id\n        }\n        ... on ReviewReportCheckinTask {\n          id\n        }\n        ... on ScoreRevieweeTask {\n          id\n        }\n        ... on SelectPeersTask {\n          id\n        }\n        ... on SetupOneOnOnesWithNewReportTask {\n          id\n        }\n        ... on SetupUpdatesWithNewReportTask {\n          id\n        }\n        ... on ShareCompensationCycleResultsToTeamTask {\n          id\n        }\n        ... on StartSurveyManagerActionPlanningTask {\n          id\n        }\n        ... on UpdateGoalTask {\n          id\n        }\n        ... on UpdateGoalsTask {\n          id\n        }\n        ... on UpdateTotalRewardsCompanyCurrencyTask {\n          id\n        }\n        ... on ViewCalibrationGroupsTask {\n          id\n        }\n        ... on ViewCompensationCycleResultsTask {\n          id\n        }\n        ... on ViewCompensationCycleTeamResultsTask {\n          id\n        }\n        ... on ViewCompensationTotalRewardsStatementTask {\n          id\n        }\n        ... on ViewSharedCompensationCycleResultsTask {\n          id\n        }\n        ... on ViewSurveyActionPlanTask {\n          id\n        }\n        ... on ViewSurveyCommentTask {\n          id\n        }\n      }\n      id\n      activeGoals: ownedGoals(state: ACTIVE, last: 100, orderBy: Priority) {\n        edges {\n          node {\n            ...GoalCard_goal\n            id\n          }\n        }\n      }\n      siblings(first: 15) {\n        edges {\n          node {\n            entityId\n            preferredName\n            title\n            email\n            name\n            avatarUrl\n            id\n          }\n        }\n      }\n      viewerIsUser\n      entityId\n      name\n      preferredName\n      title\n      startDate\n      phoneNumber\n      timezone\n      realTimezone\n      email\n      avatarUrl\n      department {\n        name\n        id\n      }\n      manager {\n        email\n        entityId\n        id\n      }\n      reportsList {\n        entityId\n        preferredName\n        avatarUrl\n        title\n        email\n        name\n        id\n      }\n      products {\n        updates {\n          isEnabled\n        }\n        feedback {\n          isEnabled\n        }\n      }\n    }\n    managerCheckinRelationship {\n      manager {\n        entityId\n        preferredName\n        title\n        email\n        name\n        avatarUrl\n        ...NextMeetingCard_user\n        id\n      }\n      hasAnyCheckins\n      isCheckinsActive\n      checkinByWeekId(weekId: $weekId, includeDraft: $includeDraft) {\n        published\n        id\n      }\n      oneOnOneMeetings(first: 5) {\n        edges {\n          node {\n            entityId\n            id\n            scheduledAt\n          }\n        }\n      }\n      nextRecurringOneOnOneMeeting {\n        __typename\n        ... on OneOnOneMeeting {\n          scheduledAt\n          id\n        }\n        id\n      }\n      id\n    }\n    receivedFeedback(first: 10) {\n      pageInfo {\n        hasNextPage\n      }\n      edges {\n        node {\n          id\n          ...FeedbackCard_feedback\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment FeedbackCard_feedback on Feedback {\n  body\n  createdAt\n  companyValues {\n    name\n    id\n  }\n  targets {\n    id\n  }\n  author {\n    avatarUrl\n    name\n    preferredName\n    ...UserChip_user\n    id\n  }\n  competency {\n    name\n    id\n  }\n}\n\nfragment GoalBadge_goal on Goal {\n  computedProgressAmount\n  entityId\n  id\n  state\n  status\n  type: computedType\n}\n\nfragment GoalCard_goal on Goal {\n  childrenList {\n    id\n  }\n  entityId\n  id\n  name\n  private\n  state\n  status\n  ...GoalProgress_goal\n  ...GoalBadge_goal\n}\n\nfragment GoalProgress_goal on Goal {\n  id\n  amountType: computedAmountType\n  goalAmount: computedGoalAmount\n  progressAmount\n  startingAmount: computedStartingAmount\n  type: computedType\n  computedProgressAmount\n}\n\nfragment NextMeetingCard_user on User {\n  id\n  ...UserChip_user\n}\n\nfragment UserChip_user on User {\n  preferredName\n  name\n  avatarUrl\n}\n"
  }
};
})();

(node as any).hash = "b7f505a4b94542b9165be3dc83eba1c2";

export default node;
